import { render } from "./MainHeader.vue?vue&type=template&id=06e101ae&scoped=true&ts=true"
import script from "./MainHeader.vue?vue&type=script&lang=ts"
export * from "./MainHeader.vue?vue&type=script&lang=ts"

import "./MainHeader.vue?vue&type=style&index=0&id=06e101ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e101ae"]])

export default __exports__